import User from "../../apis/User";
import Csrf from "../../apis/Csrf";
import Cookie from "js-cookie";

const state = {
    user: {},
};

const getters = {
    name: (state) => {
        return Object.keys(state.user).length && state.user.name ? state.user.name : "";
    },
    roles: (state) => {
        return Object.keys(state.user).length && state.user.roles.length ? state.user.roles.map((el) => el.name) : "newUser";
    },
    clientUid: (state) => {
        return state.user.client_uid;
    },
    permissions: (state) => {
        let allPermissions = [];

        if (Object.keys(state.user).length && state.user.roles.length) {
            allPermissions[0] = state.user.roles[0].permissions.map(
                (value) => value["name"]
            );
            allPermissions[1] = state.user.permissions.map(
                (value) => value["name"]
            );

            allPermissions = allPermissions.flat(Infinity);

            return allPermissions;
        } else {
            return [];
        }

        // return Object.keys(state.user).length && state.user.roles.length
        //     ?
        //     state.user.roles[0].permissions.map(
        //         (value) => value["name"]
        //     )
        //     : [];
    },
    writePermission: (state, getters) => {
        return Object.keys(state.user).length && state.user.roles.length ? getters.permissions.includes("write") : false;
    },
    readPermission: (state, getters) => {
        return Object.keys(state.user).length && state.user.roles.length ? getters.permissions.includes("read") : false;
    },
};

const actions = {
    setClientUid({ commit }, clientUid) {
        commit("SET_CLIENT_UID", clientUid);
    },
    login({ commit }, form) {
        //Csrf.getCookie();
        let a = Cookie.get("XSRF-TOKEN");
        //console.log("🚀 ~ login ~ a:", a, a === undefined);

        return new Promise((resolve, reject) => {

            User.login(form).then((response) => {
                resolve(response);
                commit("LOGIN", response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    loginToUser({ commit }, userId) {
        return new Promise((resolve, reject) => {
            User.loginToUser(userId).then((response) => {
                resolve(response);
                commit("LOGIN", response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            User.logout().then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    auth({ commit }) {
        return new Promise((resolve, reject) => {
            User.auth().then((response) => {
                resolve(response);
                commit("AUTH", response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    registerClient({ commit }, form) {
        return new Promise((resolve, reject) => {
            User.registerClient(form).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    registerUser({ commit }, form) {
        return new Promise((resolve, reject) => {
            User.registerUser(form).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
};

const mutations = {
    SET_CLIENT_UID(state, clientUid) {
        state.user.clientUid = clientUid;
    },
    LOGIN(state, response) {
        state.user = response.data;
    },
    AUTH(state, response) {
        console.log(state, response, "auth mutation")
        state.user = response.data;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
